export interface AssessmentQuestion {
  id: string;
  text: string;
}

export const SCALE_LABELS = ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'];

export const PHQ9_QUESTIONS: AssessmentQuestion[] = [
  { id: 'p1', text: 'Little interest or pleasure in doing things' },
  { id: 'p2', text: 'Feeling down, depressed, or hopeless' },
  { id: 'p3', text: 'Trouble falling or staying asleep, or sleeping too much' },
  { id: 'p4', text: 'Feeling tired or having little energy' },
  { id: 'p5', text: 'Poor appetite or overeating' },
  { id: 'p6', text: 'Feeling bad about yourself — or that you are a failure or have let yourself or your family down' },
  { id: 'p7', text: 'Trouble concentrating on things, such as reading the newspaper or watching television' },
  { id: 'p8', text: 'Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual' },
  { id: 'p9', text: 'Thoughts that you would be better off dead, or of hurting yourself in some way' },
];
